import { keyBy, merge, uniqBy, values } from 'lodash';

const monthMap = [
  { key: 'January', display: 'Jan', index: 0 },
  { key: 'February', display: 'Feb', index: 1 },
  { key: 'March', display: 'Mar', index: 2 },
  { key: 'April', display: 'April', index: 3 },
  { key: 'May', display: 'May', index: 4 },
  { key: 'June', display: 'June', index: 5 },
  { key: 'July', display: 'July', index: 6 },
  { key: 'August', display: 'Aug', index: 7 },
  { key: 'September', display: 'Sept', index: 8 },
  { key: 'October', display: 'Oct', index: 9 },
  { key: 'November', display: 'Nov', index: 10 },
  { key: 'December', display: 'Dec', index: 11 },
];

const preparedMonths: Array<{
  key: string;
  type: string;
}> = [];

const generateSeasonalConditions = () => {
  const merged = merge(keyBy(monthMap, 'key'), keyBy(uniqBy(preparedMonths, 'key'), 'key'));
  preparedMonths.length = 0;
  const conditions = values(merged);
  return conditions;
};

const prepareMonthsData = (months: string[], type: string) => {
  if (!months) {
    return;
  }
  months.forEach((month) => preparedMonths.push({ key: month, type }));
};

const getTravelConditions = (conditions: {
  highMonths: string[];
  shoulderMonths: string[];
  lowMonths: string[];
}) => {
  prepareMonthsData(conditions?.lowMonths, 'low');
  prepareMonthsData(conditions?.shoulderMonths, 'shoulder');
  prepareMonthsData(conditions?.highMonths, 'high');
  return generateSeasonalConditions();
};

export default getTravelConditions;
